const tokens = {
  "colors.neutral.0": {
    "value": "#FFFFFF",
    "variable": "var(--zenid-colors-neutral-0)"
  },
  "colors.neutral.100": {
    "value": "#F6F6F6",
    "variable": "var(--zenid-colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "#E9E9E9",
    "variable": "var(--zenid-colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "#CFCFCF",
    "variable": "var(--zenid-colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "#B3B3B3",
    "variable": "var(--zenid-colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "#828282",
    "variable": "var(--zenid-colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "#606060",
    "variable": "var(--zenid-colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "#555555",
    "variable": "var(--zenid-colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "#333333",
    "variable": "var(--zenid-colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "#222222",
    "variable": "var(--zenid-colors-neutral-900)"
  },
  "colors.neutral.1000": {
    "value": "#000000",
    "variable": "var(--zenid-colors-neutral-1000)"
  },
  "colors.light-blue.50": {
    "value": "#F0F8FE",
    "variable": "var(--zenid-colors-light-blue-50)"
  },
  "colors.light-blue.100": {
    "value": "#D7EBFE",
    "variable": "var(--zenid-colors-light-blue-100)"
  },
  "colors.light-blue.200": {
    "value": "#A6D2FC",
    "variable": "var(--zenid-colors-light-blue-200)"
  },
  "colors.light-blue.300": {
    "value": "#71B6F9",
    "variable": "var(--zenid-colors-light-blue-300)"
  },
  "colors.light-blue.400": {
    "value": "#57A6F8",
    "variable": "var(--zenid-colors-light-blue-400)"
  },
  "colors.light-blue.500": {
    "value": "#4697F6",
    "variable": "var(--zenid-colors-light-blue-500)"
  },
  "colors.light-blue.600": {
    "value": "#4289E8",
    "variable": "var(--zenid-colors-light-blue-600)"
  },
  "colors.light-blue.700": {
    "value": "#3D77D4 ",
    "variable": "var(--zenid-colors-light-blue-700)"
  },
  "colors.light-blue.800": {
    "value": "#3866C2",
    "variable": "var(--zenid-colors-light-blue-800)"
  },
  "colors.light-blue.900": {
    "value": "#3047A2",
    "variable": "var(--zenid-colors-light-blue-900)"
  },
  "colors.blue-gray.50": {
    "value": "#F6F7F9",
    "variable": "var(--zenid-colors-blue-gray-50)"
  },
  "colors.blue-gray.100": {
    "value": "#E6EAEF",
    "variable": "var(--zenid-colors-blue-gray-100)"
  },
  "colors.blue-gray.200": {
    "value": "#C1CCD7",
    "variable": "var(--zenid-colors-blue-gray-200)"
  },
  "colors.blue-gray.300": {
    "value": "#A3B2C2",
    "variable": "var(--zenid-colors-blue-gray-300)"
  },
  "colors.blue-gray.400": {
    "value": "#8399AF",
    "variable": "var(--zenid-colors-blue-gray-400)"
  },
  "colors.blue-gray.500": {
    "value": "#64809B",
    "variable": "var(--zenid-colors-blue-gray-500)"
  },
  "colors.blue-gray.600": {
    "value": "#50667C",
    "variable": "var(--zenid-colors-blue-gray-600)"
  },
  "colors.blue-gray.700": {
    "value": "#4C6276",
    "variable": "var(--zenid-colors-blue-gray-700)"
  },
  "colors.blue-gray.800": {
    "value": "#3C4D5D",
    "variable": "var(--zenid-colors-blue-gray-800)"
  },
  "colors.blue-gray.900": {
    "value": "#2C3944",
    "variable": "var(--zenid-colors-blue-gray-900)"
  },
  "colors.red.50": {
    "value": "#FEF1F1",
    "variable": "var(--zenid-colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FCD9D9",
    "variable": "var(--zenid-colors-red-100)"
  },
  "colors.red.200": {
    "value": "#F7A1A1",
    "variable": "var(--zenid-colors-red-200)"
  },
  "colors.red.300": {
    "value": "#F37272",
    "variable": "var(--zenid-colors-red-300)"
  },
  "colors.red.400": {
    "value": "#F15B5B",
    "variable": "var(--zenid-colors-red-400)"
  },
  "colors.red.500": {
    "value": "#EF4343",
    "variable": "var(--zenid-colors-red-500)"
  },
  "colors.red.600": {
    "value": "#EB1414",
    "variable": "var(--zenid-colors-red-600)"
  },
  "colors.red.700": {
    "value": "#CF1212",
    "variable": "var(--zenid-colors-red-700)"
  },
  "colors.red.800": {
    "value": "#AE0F0F",
    "variable": "var(--zenid-colors-red-800)"
  },
  "colors.red.900": {
    "value": "#8D0C0C",
    "variable": "var(--zenid-colors-red-900)"
  },
  "colors.green.50": {
    "value": "#E5F5EB",
    "variable": "var(--zenid-colors-green-50)"
  },
  "colors.green.100": {
    "value": "#C1E6CD",
    "variable": "var(--zenid-colors-green-100)"
  },
  "colors.green.200": {
    "value": "#99D6AD",
    "variable": "var(--zenid-colors-green-200)"
  },
  "colors.green.300": {
    "value": "#6DC78C",
    "variable": "var(--zenid-colors-green-300)"
  },
  "colors.green.400": {
    "value": "#49BB74",
    "variable": "var(--zenid-colors-green-400)"
  },
  "colors.green.500": {
    "value": "#19AF5C",
    "variable": "var(--zenid-colors-green-500)"
  },
  "colors.green.600": {
    "value": "#0EA051",
    "variable": "var(--zenid-colors-green-600)"
  },
  "colors.green.700": {
    "value": "#008E46",
    "variable": "var(--zenid-colors-green-700)"
  },
  "colors.green.800": {
    "value": "#007D3B",
    "variable": "var(--zenid-colors-green-800)"
  },
  "colors.green.900": {
    "value": "#005E27",
    "variable": "var(--zenid-colors-green-900)"
  },
  "colors.yellow.50": {
    "value": "#FFF9D6",
    "variable": "var(--zenid-colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FCE1AC",
    "variable": "var(--zenid-colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#F9C982",
    "variable": "var(--zenid-colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#F6B259",
    "variable": "var(--zenid-colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#F39A2F",
    "variable": "var(--zenid-colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#F39A2F",
    "variable": "var(--zenid-colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#D77504",
    "variable": "var(--zenid-colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#BE6704",
    "variable": "var(--zenid-colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#AF5F04",
    "variable": "var(--zenid-colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#914F03",
    "variable": "var(--zenid-colors-yellow-900)"
  },
  "colors.clear.white.10": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--zenid-colors-clear-white-10)"
  },
  "colors.clear.black.10": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--zenid-colors-clear-black-10)"
  },
  "colors.clear.black.50": {
    "value": "rgba(0, 0, 0, 0.5)",
    "variable": "var(--zenid-colors-clear-black-50)"
  },
  "colors.clear.black.80": {
    "value": "rgba(0, 0, 0, 0.8)",
    "variable": "var(--zenid-colors-clear-black-80)"
  },
  "colors.clear.light-blue.10": {
    "value": "rgba(66,137,232, 0.1)",
    "variable": "var(--zenid-colors-clear-light-blue-10)"
  },
  "colors.clear.light-blue.15": {
    "value": "rgba(66,137,232, 0.15)",
    "variable": "var(--zenid-colors-clear-light-blue-15)"
  },
  "colors.clear.light-blue.25": {
    "value": "rgba(66,137,232, 0.25)",
    "variable": "var(--zenid-colors-clear-light-blue-25)"
  },
  "colors.clear.cyan-blue.15": {
    "value": "rgba(66, 168, 232, 0.15)",
    "variable": "var(--zenid-colors-clear-cyan-blue-15)"
  },
  "radii.4": {
    "value": "4px",
    "variable": "var(--zenid-radii-4)"
  },
  "radii.8": {
    "value": "8px",
    "variable": "var(--zenid-radii-8)"
  },
  "radii.16": {
    "value": "16px",
    "variable": "var(--zenid-radii-16)"
  },
  "radii.none": {
    "value": "0px",
    "variable": "var(--zenid-radii-none)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--zenid-radii-full)"
  },
  "spacing.4": {
    "value": "4px",
    "variable": "var(--zenid-spacing-4)"
  },
  "spacing.8": {
    "value": "8px",
    "variable": "var(--zenid-spacing-8)"
  },
  "spacing.12": {
    "value": "12px",
    "variable": "var(--zenid-spacing-12)"
  },
  "spacing.16": {
    "value": "16px",
    "variable": "var(--zenid-spacing-16)"
  },
  "spacing.20": {
    "value": "20px",
    "variable": "var(--zenid-spacing-20)"
  },
  "spacing.24": {
    "value": "24px",
    "variable": "var(--zenid-spacing-24)"
  },
  "spacing.32": {
    "value": "32px",
    "variable": "var(--zenid-spacing-32)"
  },
  "spacing.40": {
    "value": "40px",
    "variable": "var(--zenid-spacing-40)"
  },
  "spacing.48": {
    "value": "48px",
    "variable": "var(--zenid-spacing-48)"
  },
  "spacing.56": {
    "value": "56px",
    "variable": "var(--zenid-spacing-56)"
  },
  "spacing.80": {
    "value": "80px",
    "variable": "var(--zenid-spacing-80)"
  },
  "gradients.background.gradation": {
    "value": "linear-gradient(275.32deg, rgba(66, 168, 232, 0.15) 5.12%, rgba(66, 137, 232, 0.15) 36.13%), #FFFFFF",
    "variable": "var(--zenid-gradients-background-gradation)"
  },
  "gradients.action.primary.gradation": {
    "value": "linear-gradient(275.32deg, #42A8E8 5.12%, #4289E8 36.13%)",
    "variable": "var(--zenid-gradients-action-primary-gradation)"
  },
  "gradients.action.primary.gradation-hover": {
    "value": "linear-gradient(275.32deg, #1C96E3 5.12%, #3D77D4 36.13%)",
    "variable": "var(--zenid-gradients-action-primary-gradation-hover)"
  },
  "zIndex.globalHeaderIndex": {
    "value": 1000,
    "variable": "var(--zenid-z-index-global-header-index)"
  },
  "shadows.dropShadow": {
    "value": "0px 0px 0px 1px rgba(44, 57, 68, 0.05), 0px 4px 12px rgba(0, 0, 0, 0.15)",
    "variable": "var(--zenid-shadows-drop-shadow)"
  },
  "animations.fadein": {
    "value": "fadeIn 300ms linear",
    "variable": "var(--zenid-animations-fadein)"
  },
  "animations.fadeout": {
    "value": "fadeOut 300ms linear",
    "variable": "var(--zenid-animations-fadeout)"
  },
  "fontSizes.heading-xl": {
    "value": "32px",
    "variable": "var(--zenid-font-sizes-heading-xl)"
  },
  "fontSizes.heading-l": {
    "value": "24px",
    "variable": "var(--zenid-font-sizes-heading-l)"
  },
  "fontSizes.heading-m": {
    "value": "20px",
    "variable": "var(--zenid-font-sizes-heading-m)"
  },
  "fontSizes.heading-s": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-heading-s)"
  },
  "fontSizes.heading-s-regular": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-heading-s-regular)"
  },
  "fontSizes.heading-xs": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-heading-xs)"
  },
  "fontSizes.heading-xs-regular": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-heading-xs-regular)"
  },
  "fontSizes.body-xl": {
    "value": "18px",
    "variable": "var(--zenid-font-sizes-body-xl)"
  },
  "fontSizes.body-xl-narrow": {
    "value": "18px",
    "variable": "var(--zenid-font-sizes-body-xl-narrow)"
  },
  "fontSizes.body-xl-loose": {
    "value": "18px",
    "variable": "var(--zenid-font-sizes-body-xl-loose)"
  },
  "fontSizes.body-l": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-body-l)"
  },
  "fontSizes.body-l-narrow": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-body-l-narrow)"
  },
  "fontSizes.body-l-loose": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-body-l-loose)"
  },
  "fontSizes.body-m": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-body-m)"
  },
  "fontSizes.body-m-narrow": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-body-m-narrow)"
  },
  "fontSizes.body-m-loose": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-body-m-loose)"
  },
  "fontSizes.body-s": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-body-s)"
  },
  "fontSizes.body-s-narrow": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-body-s-narrow)"
  },
  "fontSizes.body-s-loose": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-body-s-loose)"
  },
  "fontSizes.caption-m": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-caption-m)"
  },
  "fontSizes.caption-s": {
    "value": "10px",
    "variable": "var(--zenid-font-sizes-caption-s)"
  },
  "fontSizes.label-m": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-label-m)"
  },
  "fontSizes.label-s": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-label-s)"
  },
  "fontSizes.button-l": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-button-l)"
  },
  "fontSizes.button-m": {
    "value": "14px",
    "variable": "var(--zenid-font-sizes-button-m)"
  },
  "fontSizes.button-s": {
    "value": "12px",
    "variable": "var(--zenid-font-sizes-button-s)"
  },
  "fontSizes.textfield-m": {
    "value": "16px",
    "variable": "var(--zenid-font-sizes-textfield-m)"
  },
  "fontWeights.heading-xl": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-heading-xl)"
  },
  "fontWeights.heading-l": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-heading-l)"
  },
  "fontWeights.heading-m": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-heading-m)"
  },
  "fontWeights.heading-s": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-heading-s)"
  },
  "fontWeights.heading-s-regular": {
    "value": "400",
    "variable": "var(--zenid-font-weights-heading-s-regular)"
  },
  "fontWeights.heading-xs": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-heading-xs)"
  },
  "fontWeights.heading-xs-regular": {
    "value": "400",
    "variable": "var(--zenid-font-weights-heading-xs-regular)"
  },
  "fontWeights.body-xl": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-xl)"
  },
  "fontWeights.body-xl-narrow": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-xl-narrow)"
  },
  "fontWeights.body-xl-loose": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-xl-loose)"
  },
  "fontWeights.body-l": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-l)"
  },
  "fontWeights.body-l-narrow": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-l-narrow)"
  },
  "fontWeights.body-l-loose": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-l-loose)"
  },
  "fontWeights.body-m": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-m)"
  },
  "fontWeights.body-m-narrow": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-m-narrow)"
  },
  "fontWeights.body-m-loose": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-m-loose)"
  },
  "fontWeights.body-s": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-s)"
  },
  "fontWeights.body-s-narrow": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-s-narrow)"
  },
  "fontWeights.body-s-loose": {
    "value": "400",
    "variable": "var(--zenid-font-weights-body-s-loose)"
  },
  "fontWeights.caption-m": {
    "value": "400",
    "variable": "var(--zenid-font-weights-caption-m)"
  },
  "fontWeights.caption-s": {
    "value": "400",
    "variable": "var(--zenid-font-weights-caption-s)"
  },
  "fontWeights.label-m": {
    "value": "400",
    "variable": "var(--zenid-font-weights-label-m)"
  },
  "fontWeights.label-s": {
    "value": "400",
    "variable": "var(--zenid-font-weights-label-s)"
  },
  "fontWeights.button-l": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-button-l)"
  },
  "fontWeights.button-m": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-button-m)"
  },
  "fontWeights.button-s": {
    "value": "bold",
    "variable": "var(--zenid-font-weights-button-s)"
  },
  "fontWeights.textfield-m": {
    "value": "400",
    "variable": "var(--zenid-font-weights-textfield-m)"
  },
  "lineHeights.heading-xl": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-xl)"
  },
  "lineHeights.heading-l": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-l)"
  },
  "lineHeights.heading-m": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-m)"
  },
  "lineHeights.heading-s": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-s)"
  },
  "lineHeights.heading-s-regular": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-s-regular)"
  },
  "lineHeights.heading-xs": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-xs)"
  },
  "lineHeights.heading-xs-regular": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-heading-xs-regular)"
  },
  "lineHeights.body-xl": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-body-xl)"
  },
  "lineHeights.body-xl-narrow": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-body-xl-narrow)"
  },
  "lineHeights.body-xl-loose": {
    "value": "2.0",
    "variable": "var(--zenid-line-heights-body-xl-loose)"
  },
  "lineHeights.body-l": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-body-l)"
  },
  "lineHeights.body-l-narrow": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-body-l-narrow)"
  },
  "lineHeights.body-l-loose": {
    "value": "2.0",
    "variable": "var(--zenid-line-heights-body-l-loose)"
  },
  "lineHeights.body-m": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-body-m)"
  },
  "lineHeights.body-m-narrow": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-body-m-narrow)"
  },
  "lineHeights.body-m-loose": {
    "value": "2.0",
    "variable": "var(--zenid-line-heights-body-m-loose)"
  },
  "lineHeights.body-s": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-body-s)"
  },
  "lineHeights.body-s-narrow": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-body-s-narrow)"
  },
  "lineHeights.body-s-loose": {
    "value": "2.0",
    "variable": "var(--zenid-line-heights-body-s-loose)"
  },
  "lineHeights.caption-m": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-caption-m)"
  },
  "lineHeights.caption-s": {
    "value": "1.7",
    "variable": "var(--zenid-line-heights-caption-s)"
  },
  "lineHeights.label-m": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-label-m)"
  },
  "lineHeights.label-s": {
    "value": "1.5",
    "variable": "var(--zenid-line-heights-label-s)"
  },
  "lineHeights.button-l": {
    "value": "1.2",
    "variable": "var(--zenid-line-heights-button-l)"
  },
  "lineHeights.button-m": {
    "value": "1.2",
    "variable": "var(--zenid-line-heights-button-m)"
  },
  "lineHeights.button-s": {
    "value": "1.2",
    "variable": "var(--zenid-line-heights-button-s)"
  },
  "lineHeights.textfield-m": {
    "value": "1.2",
    "variable": "var(--zenid-line-heights-textfield-m)"
  },
  "letterSpacings.heading-xl": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-xl)"
  },
  "letterSpacings.heading-l": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-l)"
  },
  "letterSpacings.heading-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-m)"
  },
  "letterSpacings.heading-s": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-s)"
  },
  "letterSpacings.heading-s-regular": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-s-regular)"
  },
  "letterSpacings.heading-xs": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-xs)"
  },
  "letterSpacings.heading-xs-regular": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-heading-xs-regular)"
  },
  "letterSpacings.body-xl": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-xl)"
  },
  "letterSpacings.body-xl-narrow": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-xl-narrow)"
  },
  "letterSpacings.body-xl-loose": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-xl-loose)"
  },
  "letterSpacings.body-l": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-l)"
  },
  "letterSpacings.body-l-narrow": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-l-narrow)"
  },
  "letterSpacings.body-l-loose": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-l-loose)"
  },
  "letterSpacings.body-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-m)"
  },
  "letterSpacings.body-m-narrow": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-m-narrow)"
  },
  "letterSpacings.body-m-loose": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-m-loose)"
  },
  "letterSpacings.body-s": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-s)"
  },
  "letterSpacings.body-s-narrow": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-s-narrow)"
  },
  "letterSpacings.body-s-loose": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-body-s-loose)"
  },
  "letterSpacings.caption-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-caption-m)"
  },
  "letterSpacings.caption-s": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-caption-s)"
  },
  "letterSpacings.label-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-label-m)"
  },
  "letterSpacings.label-s": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-label-s)"
  },
  "letterSpacings.button-l": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-button-l)"
  },
  "letterSpacings.button-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-button-m)"
  },
  "letterSpacings.button-s": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-button-s)"
  },
  "letterSpacings.textfield-m": {
    "value": "0.04em",
    "variable": "var(--zenid-letter-spacings-textfield-m)"
  },
  "breakpoints.sm": {
    "value": "600px",
    "variable": "var(--zenid-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "960px",
    "variable": "var(--zenid-breakpoints-md)"
  },
  "sizes.breakpoint-sm": {
    "value": "600px",
    "variable": "var(--zenid-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "960px",
    "variable": "var(--zenid-sizes-breakpoint-md)"
  },
  "colors.text.main": {
    "value": "var(--zenid-colors-neutral-800)",
    "variable": "var(--zenid-colors-text-main)"
  },
  "colors.text.sub": {
    "value": "var(--zenid-colors-neutral-600)",
    "variable": "var(--zenid-colors-text-sub)"
  },
  "colors.text.white": {
    "value": "var(--zenid-colors-neutral-0)",
    "variable": "var(--zenid-colors-text-white)"
  },
  "colors.text.link": {
    "value": "var(--zenid-colors-light-blue-600)",
    "variable": "var(--zenid-colors-text-link)"
  },
  "colors.text.link-hover": {
    "value": "var(--zenid-colors-light-blue-800)",
    "variable": "var(--zenid-colors-text-link-hover)"
  },
  "colors.text.placeholder": {
    "value": "var(--zenid-colors-neutral-500)",
    "variable": "var(--zenid-colors-text-placeholder)"
  },
  "colors.text.disabled": {
    "value": "var(--zenid-colors-neutral-300)",
    "variable": "var(--zenid-colors-text-disabled)"
  },
  "colors.border.light": {
    "value": "var(--zenid-colors-blue-gray-100)",
    "variable": "var(--zenid-colors-border-light)"
  },
  "colors.border.dark": {
    "value": "var(--zenid-colors-blue-gray-200)",
    "variable": "var(--zenid-colors-border-dark)"
  },
  "colors.border.focus": {
    "value": "var(--zenid-colors-clear-light-blue-25)",
    "variable": "var(--zenid-colors-border-focus)"
  },
  "colors.background.white": {
    "value": "var(--zenid-colors-neutral-0)",
    "variable": "var(--zenid-colors-background-white)"
  },
  "colors.background.blue-gray": {
    "value": "var(--zenid-colors-blue-gray-50)",
    "variable": "var(--zenid-colors-background-blue-gray)"
  },
  "colors.background.backdrop": {
    "value": "var(--zenid-colors-clear-black-50)",
    "variable": "var(--zenid-colors-background-backdrop)"
  },
  "colors.hover.black": {
    "value": "var(--zenid-colors-clear-black-10)",
    "variable": "var(--zenid-colors-hover-black)"
  },
  "colors.hover.white": {
    "value": "var(--zenid-colors-clear-white-10)",
    "variable": "var(--zenid-colors-hover-white)"
  },
  "colors.hover.light-blue": {
    "value": "var(--zenid-colors-clear-light-blue-10)",
    "variable": "var(--zenid-colors-hover-light-blue)"
  },
  "colors.action.disabled": {
    "value": "var(--zenid-colors-neutral-300)",
    "variable": "var(--zenid-colors-action-disabled)"
  },
  "colors.action.primary.main": {
    "value": "var(--zenid-colors-light-blue-600)",
    "variable": "var(--zenid-colors-action-primary-main)"
  },
  "colors.action.primary.contrast": {
    "value": "var(--zenid-colors-neutral-0)",
    "variable": "var(--zenid-colors-action-primary-contrast)"
  },
  "colors.action.secondary.main": {
    "value": "var(--zenid-colors-neutral-0)",
    "variable": "var(--zenid-colors-action-secondary-main)"
  },
  "colors.action.secondary.contrast": {
    "value": "var(--zenid-colors-neutral-800)",
    "variable": "var(--zenid-colors-action-secondary-contrast)"
  },
  "colors.action.secondary.hover": {
    "value": "var(--zenid-colors-neutral-200)",
    "variable": "var(--zenid-colors-action-secondary-hover)"
  },
  "colors.action.secondary.focus": {
    "value": "var(--zenid-colors-clear-light-blue-25)",
    "variable": "var(--zenid-colors-action-secondary-focus)"
  },
  "colors.action.tertiary.main": {
    "value": "var(--zenid-colors-light-blue-600)",
    "variable": "var(--zenid-colors-action-tertiary-main)"
  },
  "colors.action.tertiary.hover": {
    "value": "var(--zenid-colors-clear-light-blue-10)",
    "variable": "var(--zenid-colors-action-tertiary-hover)"
  },
  "colors.action.warning.main": {
    "value": "var(--zenid-colors-red-500)",
    "variable": "var(--zenid-colors-action-warning-main)"
  },
  "colors.action.warning.background": {
    "value": "var(--zenid-colors-red-50)",
    "variable": "var(--zenid-colors-action-warning-background)"
  },
  "colors.action.success.main": {
    "value": "var(--zenid-colors-green-600)",
    "variable": "var(--zenid-colors-action-success-main)"
  },
  "colors.action.success.background": {
    "value": "var(--zenid-colors-green-50)",
    "variable": "var(--zenid-colors-action-success-background)"
  },
  "colors.action.info.main": {
    "value": "var(--zenid-colors-light-blue-600)",
    "variable": "var(--zenid-colors-action-info-main)"
  },
  "colors.action.info.background": {
    "value": "var(--zenid-colors-light-blue-50)",
    "variable": "var(--zenid-colors-action-info-background)"
  },
  "colors.action.notice.main": {
    "value": "var(--zenid-colors-yellow-600)",
    "variable": "var(--zenid-colors-action-notice-main)"
  },
  "colors.action.notice.background": {
    "value": "var(--zenid-colors-yellow-50)",
    "variable": "var(--zenid-colors-action-notice-background)"
  },
  "spacing.-4": {
    "value": "calc(var(--zenid-spacing-4) * -1)",
    "variable": "var(--zenid-spacing-4)"
  },
  "spacing.-8": {
    "value": "calc(var(--zenid-spacing-8) * -1)",
    "variable": "var(--zenid-spacing-8)"
  },
  "spacing.-12": {
    "value": "calc(var(--zenid-spacing-12) * -1)",
    "variable": "var(--zenid-spacing-12)"
  },
  "spacing.-16": {
    "value": "calc(var(--zenid-spacing-16) * -1)",
    "variable": "var(--zenid-spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--zenid-spacing-20) * -1)",
    "variable": "var(--zenid-spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--zenid-spacing-24) * -1)",
    "variable": "var(--zenid-spacing-24)"
  },
  "spacing.-32": {
    "value": "calc(var(--zenid-spacing-32) * -1)",
    "variable": "var(--zenid-spacing-32)"
  },
  "spacing.-40": {
    "value": "calc(var(--zenid-spacing-40) * -1)",
    "variable": "var(--zenid-spacing-40)"
  },
  "spacing.-48": {
    "value": "calc(var(--zenid-spacing-48) * -1)",
    "variable": "var(--zenid-spacing-48)"
  },
  "spacing.-56": {
    "value": "calc(var(--zenid-spacing-56) * -1)",
    "variable": "var(--zenid-spacing-56)"
  },
  "spacing.-80": {
    "value": "calc(var(--zenid-spacing-80) * -1)",
    "variable": "var(--zenid-spacing-80)"
  },
  "colors.colorPalette.0": {
    "value": "var(--zenid-colors-color-palette-0)",
    "variable": "var(--zenid-colors-color-palette-0)"
  },
  "colors.colorPalette.100": {
    "value": "var(--zenid-colors-color-palette-100)",
    "variable": "var(--zenid-colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--zenid-colors-color-palette-200)",
    "variable": "var(--zenid-colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--zenid-colors-color-palette-300)",
    "variable": "var(--zenid-colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--zenid-colors-color-palette-400)",
    "variable": "var(--zenid-colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--zenid-colors-color-palette-500)",
    "variable": "var(--zenid-colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--zenid-colors-color-palette-600)",
    "variable": "var(--zenid-colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--zenid-colors-color-palette-700)",
    "variable": "var(--zenid-colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--zenid-colors-color-palette-800)",
    "variable": "var(--zenid-colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--zenid-colors-color-palette-900)",
    "variable": "var(--zenid-colors-color-palette-900)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--zenid-colors-color-palette-1000)",
    "variable": "var(--zenid-colors-color-palette-1000)"
  },
  "colors.colorPalette.50": {
    "value": "var(--zenid-colors-color-palette-50)",
    "variable": "var(--zenid-colors-color-palette-50)"
  },
  "colors.colorPalette.white.10": {
    "value": "var(--zenid-colors-color-palette-white-10)",
    "variable": "var(--zenid-colors-color-palette-white-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--zenid-colors-color-palette-10)",
    "variable": "var(--zenid-colors-color-palette-10)"
  },
  "colors.colorPalette.black.10": {
    "value": "var(--zenid-colors-color-palette-black-10)",
    "variable": "var(--zenid-colors-color-palette-black-10)"
  },
  "colors.colorPalette.black.50": {
    "value": "var(--zenid-colors-color-palette-black-50)",
    "variable": "var(--zenid-colors-color-palette-black-50)"
  },
  "colors.colorPalette.black.80": {
    "value": "var(--zenid-colors-color-palette-black-80)",
    "variable": "var(--zenid-colors-color-palette-black-80)"
  },
  "colors.colorPalette.80": {
    "value": "var(--zenid-colors-color-palette-80)",
    "variable": "var(--zenid-colors-color-palette-80)"
  },
  "colors.colorPalette.light-blue.10": {
    "value": "var(--zenid-colors-color-palette-light-blue-10)",
    "variable": "var(--zenid-colors-color-palette-light-blue-10)"
  },
  "colors.colorPalette.light-blue.15": {
    "value": "var(--zenid-colors-color-palette-light-blue-15)",
    "variable": "var(--zenid-colors-color-palette-light-blue-15)"
  },
  "colors.colorPalette.15": {
    "value": "var(--zenid-colors-color-palette-15)",
    "variable": "var(--zenid-colors-color-palette-15)"
  },
  "colors.colorPalette.light-blue.25": {
    "value": "var(--zenid-colors-color-palette-light-blue-25)",
    "variable": "var(--zenid-colors-color-palette-light-blue-25)"
  },
  "colors.colorPalette.25": {
    "value": "var(--zenid-colors-color-palette-25)",
    "variable": "var(--zenid-colors-color-palette-25)"
  },
  "colors.colorPalette.cyan-blue.15": {
    "value": "var(--zenid-colors-color-palette-cyan-blue-15)",
    "variable": "var(--zenid-colors-color-palette-cyan-blue-15)"
  },
  "colors.colorPalette.main": {
    "value": "var(--zenid-colors-color-palette-main)",
    "variable": "var(--zenid-colors-color-palette-main)"
  },
  "colors.colorPalette.sub": {
    "value": "var(--zenid-colors-color-palette-sub)",
    "variable": "var(--zenid-colors-color-palette-sub)"
  },
  "colors.colorPalette.white": {
    "value": "var(--zenid-colors-color-palette-white)",
    "variable": "var(--zenid-colors-color-palette-white)"
  },
  "colors.colorPalette.link": {
    "value": "var(--zenid-colors-color-palette-link)",
    "variable": "var(--zenid-colors-color-palette-link)"
  },
  "colors.colorPalette.link-hover": {
    "value": "var(--zenid-colors-color-palette-link-hover)",
    "variable": "var(--zenid-colors-color-palette-link-hover)"
  },
  "colors.colorPalette.placeholder": {
    "value": "var(--zenid-colors-color-palette-placeholder)",
    "variable": "var(--zenid-colors-color-palette-placeholder)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--zenid-colors-color-palette-disabled)",
    "variable": "var(--zenid-colors-color-palette-disabled)"
  },
  "colors.colorPalette.light": {
    "value": "var(--zenid-colors-color-palette-light)",
    "variable": "var(--zenid-colors-color-palette-light)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--zenid-colors-color-palette-dark)",
    "variable": "var(--zenid-colors-color-palette-dark)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--zenid-colors-color-palette-focus)",
    "variable": "var(--zenid-colors-color-palette-focus)"
  },
  "colors.colorPalette.blue-gray": {
    "value": "var(--zenid-colors-color-palette-blue-gray)",
    "variable": "var(--zenid-colors-color-palette-blue-gray)"
  },
  "colors.colorPalette.backdrop": {
    "value": "var(--zenid-colors-color-palette-backdrop)",
    "variable": "var(--zenid-colors-color-palette-backdrop)"
  },
  "colors.colorPalette.black": {
    "value": "var(--zenid-colors-color-palette-black)",
    "variable": "var(--zenid-colors-color-palette-black)"
  },
  "colors.colorPalette.light-blue": {
    "value": "var(--zenid-colors-color-palette-light-blue)",
    "variable": "var(--zenid-colors-color-palette-light-blue)"
  },
  "colors.colorPalette.primary.main": {
    "value": "var(--zenid-colors-color-palette-primary-main)",
    "variable": "var(--zenid-colors-color-palette-primary-main)"
  },
  "colors.colorPalette.primary.contrast": {
    "value": "var(--zenid-colors-color-palette-primary-contrast)",
    "variable": "var(--zenid-colors-color-palette-primary-contrast)"
  },
  "colors.colorPalette.contrast": {
    "value": "var(--zenid-colors-color-palette-contrast)",
    "variable": "var(--zenid-colors-color-palette-contrast)"
  },
  "colors.colorPalette.secondary.main": {
    "value": "var(--zenid-colors-color-palette-secondary-main)",
    "variable": "var(--zenid-colors-color-palette-secondary-main)"
  },
  "colors.colorPalette.secondary.contrast": {
    "value": "var(--zenid-colors-color-palette-secondary-contrast)",
    "variable": "var(--zenid-colors-color-palette-secondary-contrast)"
  },
  "colors.colorPalette.secondary.hover": {
    "value": "var(--zenid-colors-color-palette-secondary-hover)",
    "variable": "var(--zenid-colors-color-palette-secondary-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--zenid-colors-color-palette-hover)",
    "variable": "var(--zenid-colors-color-palette-hover)"
  },
  "colors.colorPalette.secondary.focus": {
    "value": "var(--zenid-colors-color-palette-secondary-focus)",
    "variable": "var(--zenid-colors-color-palette-secondary-focus)"
  },
  "colors.colorPalette.tertiary.main": {
    "value": "var(--zenid-colors-color-palette-tertiary-main)",
    "variable": "var(--zenid-colors-color-palette-tertiary-main)"
  },
  "colors.colorPalette.tertiary.hover": {
    "value": "var(--zenid-colors-color-palette-tertiary-hover)",
    "variable": "var(--zenid-colors-color-palette-tertiary-hover)"
  },
  "colors.colorPalette.warning.main": {
    "value": "var(--zenid-colors-color-palette-warning-main)",
    "variable": "var(--zenid-colors-color-palette-warning-main)"
  },
  "colors.colorPalette.warning.background": {
    "value": "var(--zenid-colors-color-palette-warning-background)",
    "variable": "var(--zenid-colors-color-palette-warning-background)"
  },
  "colors.colorPalette.background": {
    "value": "var(--zenid-colors-color-palette-background)",
    "variable": "var(--zenid-colors-color-palette-background)"
  },
  "colors.colorPalette.success.main": {
    "value": "var(--zenid-colors-color-palette-success-main)",
    "variable": "var(--zenid-colors-color-palette-success-main)"
  },
  "colors.colorPalette.success.background": {
    "value": "var(--zenid-colors-color-palette-success-background)",
    "variable": "var(--zenid-colors-color-palette-success-background)"
  },
  "colors.colorPalette.info.main": {
    "value": "var(--zenid-colors-color-palette-info-main)",
    "variable": "var(--zenid-colors-color-palette-info-main)"
  },
  "colors.colorPalette.info.background": {
    "value": "var(--zenid-colors-color-palette-info-background)",
    "variable": "var(--zenid-colors-color-palette-info-background)"
  },
  "colors.colorPalette.notice.main": {
    "value": "var(--zenid-colors-color-palette-notice-main)",
    "variable": "var(--zenid-colors-color-palette-notice-main)"
  },
  "colors.colorPalette.notice.background": {
    "value": "var(--zenid-colors-color-palette-notice-background)",
    "variable": "var(--zenid-colors-color-palette-notice-background)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar